// src/data/comedians/charlie-chaplin.js

const base = {
  id: 'charlie-chaplin',
  slug: 'charlie-chaplin',
  name: 'Charlie Chaplin',
  birthYear: 1889,
  image: require('@/assets/images/img_Charlie_Chaplin.jpg'),
  famousWorks: [
    'The Kid (1921)',
    'The Gold Rush (1925)',
    'City Lights (1931)',
    'Modern Times (1936)',
    'The Great Dictator (1940)',
    'Limelight (1952)',
  ],
};

export default [
  {
    ...base,
    lang: 'en',
    nationality: 'British',
    shortBio: 'Silent film pioneer and The Tramp',
    bio: `Sir Charles Spencer Chaplin was an English comic actor, filmmaker, and composer who rose to fame in the era of silent film. His iconic character "The Tramp" became one of the most recognizable figures in cinema history.\n\nBorn in London to music hall entertainers, Chaplin's childhood was marked by poverty and hardship. He began performing at a young age and joined a traveling comedy troupe before moving to America in 1913.\n\nChaplin revolutionized cinema with his unique blend of slapstick comedy and pathos. His films tackled serious social issues while maintaining universal appeal. As a filmmaker, he wrote, directed, produced, edited, and composed music for most of his work. His influence on cinema and comedy is immeasurable.`,
    style: 'Physical comedy, pantomime, visual storytelling with emotional depth',
    achievements: [
      'Academy Honorary Award (1972)',
      'Knighted by Queen Elizabeth II (1975)',
      'AFI ranked "The Tramp" as the greatest movie character of all time',
      'Co-founder of United Artists studio',
      'Three Academy Awards (Honorary, Best Score, nomination)',
    ],
  },
  {
    ...base,
    lang: 'fr',
    nationality: 'Britannique',
    shortBio: 'Pionnier du cinéma muet et créateur de Charlot',
    bio: `Sir Charles Spencer Chaplin était un acteur comique, cinéaste et compositeur anglais qui s'est imposé à l'ère du cinéma muet. Son personnage emblématique « Charlot » est devenu l'une des figures les plus reconnaissables de l'histoire du cinéma.\n\nNé à Londres dans une famille de music-hall, l'enfance de Chaplin fut marquée par la pauvreté. Il débuta sur scène très jeune et rejoignit une troupe ambulante avant de s'installer en Amérique en 1913.\n\nChaplin a révolutionné le cinéma en mêlant slapstick et émotion profonde. Ses films abordaient des questions sociales graves tout en conservant un attrait universel. Véritable homme-orchestre, il écrivait, réalisait, produisait, montait et composait la musique de ses œuvres.`,
    style: 'Comédie physique, pantomime, narration visuelle avec une profondeur émotionnelle',
    achievements: [
      'Oscar honorifique (1972)',
      'Anobli par la Reine Élisabeth II (1975)',
      'L\'AFI classe « Charlot » comme le plus grand personnage de cinéma de tous les temps',
      'Cofondateur du studio United Artists',
      'Trois Oscars (honorifique, meilleure musique, nomination)',
    ],
  },
  {
    ...base,
    lang: 'es',
    nationality: 'Británico',
    shortBio: 'Pionero del cine mudo y creador de El Vagabundo',
    bio: `Sir Charles Spencer Chaplin fue un actor cómico, cineasta y compositor inglés que alcanzó la fama en la era del cine mudo. Su icónico personaje "El Vagabundo" se convirtió en una de las figuras más reconocibles en la historia del cine.\n\nNacido en Londres en una familia de artistas de music-hall, la infancia de Chaplin estuvo marcada por la pobreza. Comenzó a actuar desde joven y se unió a una compañía ambulante antes de trasladarse a América en 1913.\n\nChaplin revolucionó el cine con su mezcla única de slapstick y patetismo. Sus películas abordaban cuestiones sociales serias manteniendo un atractivo universal. Como cineasta, escribió, dirigió, produjo, editó y compuso la música de la mayoría de sus obras.`,
    style: 'Comedia física, pantomima, narración visual con profundidad emocional',
    achievements: [
      'Oscar Honorífico (1972)',
      'Nombrado Caballero por la Reina Isabel II (1975)',
      'El AFI clasificó a "El Vagabundo" como el mejor personaje cinematográfico de todos los tiempos',
      'Cofundador del estudio United Artists',
      'Tres premios Oscar (honorífico, mejor música, nominación)',
    ],
  },
  {
    ...base,
    lang: 'ar',
    nationality: 'بريطاني',
    shortBio: 'رائد السينما الصامتة وخالق شخصية المتشرد',
    bio: `السير تشارلز سبنسر شابلن ممثل كوميدي وصانع أفلام وملحّن إنجليزي نال الشهرة في عصر السينما الصامتة. وأصبحت شخصيته الأيقونية "المتشرد" واحدة من أكثر الشخصيات شهرةً في تاريخ السينما.\n\nوُلد في لندن لعائلة من فناني المسرح الغنائي، وطبعت الفقر طفولته. بدأ التمثيل في سن مبكرة وانضم إلى فرقة متنقلة قبل أن ينتقل إلى أمريكا عام 1913.\n\nأحدث شابلن ثورة في السينما بمزجه الفريد بين الكوميديا الجسدية والعمق العاطفي. تناولت أفلامه قضايا اجتماعية جدية مع الحفاظ على جاذبية عالمية. وكصانع أفلام كان يكتب ويخرج وينتج ويحرر ويؤلف موسيقى أعماله بنفسه.`,
    style: 'الكوميديا الجسدية، فن البانتومايم، السرد البصري بعمق عاطفي',
    achievements: [
      'جائزة الأوسكار الفخرية (1972)',
      'حصل على لقب فارس من الملكة إليزابيث الثانية (1975)',
      'صنّف AFI شخصية "المتشرد" أعظم شخصية سينمائية في التاريخ',
      'أحد المؤسسين المشاركين لاستوديو United Artists',
      'ثلاث جوائز أوسكار (فخرية وأفضل موسيقى وترشيح)',
    ],
  },
];
